import { callApi } from 'utils/api'

const cleanParams = (params) => Object.fromEntries(
	Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
)

// Todas las operaciones usan el token de la sesion de SuperAdmin.
const getHeaders = (state) => ({
	token: state?.app?.superAdmin?.token,
})

// Obtiene el historial paginado de solicitudes.
export const getQueryRequests = (params = {}) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi('/queries_request', {
				method: 'GET',
				headers: getHeaders(state),
				params: cleanParams({
					...params,
					paginated: 'true',
					page: params.page ?? 1,
					limit: params.limit ?? 50,
				}),
			})
			const body = res.body

			dispatch({
				type: 'LOAD_QUERIES_REQUESTS',
				payload: Array.isArray(body?.items) ? body.items : [],
			})
			return body
		} catch (error) {
			console.error('Error fetching query requests:', error)
			dispatch({ type: 'LOAD_QUERIES_REQUESTS_FAILURE', error })
			throw error
		}
	}
}

// Carga todas las paginas que coinciden con la busqueda para exportacion.
// No modifica el listado visible ni vuelve a ejecutar SQL.
export const fetchAllQueryRequests = (params = {}) => async (dispatch, getState) => {
	const limit = Number(params.limit) || 200
	let page = 1
	let totalPages = 1
	const items = []

	do {
		const state = getState()
		const res = await callApi('/queries_request', {
			method: 'GET',
			headers: getHeaders(state),
			params: cleanParams({
				...params,
				paginated: 'true',
				page,
				limit,
			}),
		})
		const body = res.body
		items.push(...(Array.isArray(body?.items) ? body.items : []))
		totalPages = body?.pagination?.total_pages || 1
		page += 1
	} while (page <= totalPages)

	return items
}

// Registra una solicitud sin ejecutar el SQL. La API recibe el lote como
// una cadena JSON en la propiedad `queries`.
export const createQueryRequest = (queries) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi('/queries_request', {
				method: 'POST',
				headers: getHeaders(state),
				body: JSON.stringify({ queries: JSON.stringify(queries) }),
			})

			dispatch({ type: 'ADD_QUERIES_REQUEST', response: res.body })
			return res.body
		} catch (error) {
			console.error('Error creating query request:', error)
			dispatch({ type: 'ADD_QUERIES_REQUEST_FAILURE', error })
			throw error
		}
	}
}

// Aprueba o rechaza una solicitud.
export const resolveQueryRequest = (id, decision, reason = '') => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/queries_request/${id}/resolve`, {
				method: 'POST',
				headers: getHeaders(state),
				body: JSON.stringify({ decision, motivo: reason }),
			})

			dispatch({ type: 'RESOLVE_QUERIES_REQUEST', response: res.body })
			return res.body
		} catch (error) {
			console.error('Error resolving query request:', error)
			dispatch({ type: 'RESOLVE_QUERIES_REQUEST_FAILURE', error })
			throw error
		}
	}
}

// Marca como ERROR una solicitud que quedo en estado EJECUTANDO.
export const recoverQueryRequest = (id) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/queries_request/${id}/error`, {
				method: 'POST',
				headers: getHeaders(state),
				body: JSON.stringify({}),
			})

			dispatch({ type: 'RECOVER_QUERIES_REQUEST', response: res.body })
			return res.body
		} catch (error) {
			console.error('Error recovering query request:', error)
			dispatch({ type: 'RECOVER_QUERIES_REQUEST_FAILURE', error })
			throw error
		}
	}
}

export default {
	getQueryRequests,
	fetchAllQueryRequests,
	createQueryRequest,
	resolveQueryRequest,
	recoverQueryRequest,
}
